import { Injectable } from '@angular/core';
import { IContext, IContextContactInfo } from '@ext-interfaces/context.model';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class GoogleContextService implements IContext {
    constructor() {}

    private readonly _contactInfo = new BehaviorSubject<IContextContactInfo | undefined>(undefined);
    public readonly $contactInfo: Observable<IContextContactInfo> = this._contactInfo.asObservable();
}
